import { LDContext, LDProvider } from 'launchdarkly-react-client-sdk';
import getConfig from '@/lib/config/index';
import React from 'react';
import { TENANT_IDENTIFIER } from '@/modules/services/base';

export const LDContextProvider: React.FC = ({ children }) => {
  const ldContext: LDContext = { key: TENANT_IDENTIFIER };

  return (
    <LDProvider
      clientSideID={getConfig.launchDarklyClientSideId}
      context={ldContext}
    >
      {children}
    </LDProvider>
  );
};

export default LDContextProvider;
